import {
    ANYTIME_FEEDBACK_PROVIDE,
    ANYTIME_FEEDBACK_REQUEST_EDIT,
    FEEDBACK_PROVIDE,
    FEEDBACK_USER_VIEW,
    FEEDBACK_USER_VIEW_MULTIPLE,
} from '../../../../routes';
import { interpolateAppUrl } from '../../../services/Url';
import { FeedbackDto } from '../types';

export const getFeedbackViewUrl = (id: string): string => interpolateAppUrl(FEEDBACK_USER_VIEW)({ id: id });

export const getFeedbackYouProvidedViewUrl = (id: string): string =>
    interpolateAppUrl(FEEDBACK_USER_VIEW_MULTIPLE)({ id: id });

export const getFeedbackYouProvidedViewStandaloneUrl = (id: string): string =>
    interpolateAppUrl(FEEDBACK_USER_VIEW)({ id: id });

export const getAnytimeFbEditUrl = (feedback: FeedbackDto): string => {
    return interpolateAppUrl(ANYTIME_FEEDBACK_REQUEST_EDIT)({
        id: feedback.id,
    });
};

export const getFeedbackProvideUrl = (feedback: FeedbackDto, responseId: string): string => {
    switch (feedback.type) {
        case 'REQUESTED':
            return interpolateAppUrl(ANYTIME_FEEDBACK_PROVIDE)({
                requestId: feedback.id,
                reviewerId: responseId,
            });
        case 'CYCLE':
            return interpolateAppUrl(FEEDBACK_PROVIDE)({
                id: responseId,
            });
    }
};
